import BaseClass from "../../util/BaseClass";
import Context from "../../context/Context";
import * as val from "../../util/val";
import * as versionUtil from "./versionUtil";

export default class VersionManager extends BaseClass {

  featureServicePerPlan = true;
  serviceInfo;
  url;
  versionInfos;

  //deleteVersion: (versionInfo) : admin/owner(permission): disable delete button if not
  //canDelete(versionInfo): boolean
  //getVersionedBranch()


  createVersion(task,newVersionInfo) {
    /*
      versionName
      description
      accessPermission  private | public | protected | hidden
     */
    newVersionInfo.f = "json";
    //newVersionInfo.accessPermission = "public";
    //newVersionInfo.ownerName = "urban@indoors";
    //newVersionInfo.access = "public";
    const lib = Context.instance.lib;
    let url = (task && task.versionManagerUrl) || this.url;
    url += "/create";
    const options = {query: newVersionInfo, method: "post", responseType: "json"};
    const promise = lib.esri.esriRequest(url,options);
    promise.then(result => {
      task.createVersionResult = result && result.data;
    });
    return promise;
  }

  deleteVersion(versionInfo){
    const promise = new Promise((resolve,reject) => {
      const lib = Context.instance.lib;
      let url = this.url;
      url += "/delete";
      const params = {
        f: "json",
        versionName: versionInfo.versionName
      }
      const options = {query: params, method: "post", responseType: "json"};
      lib.esri.esriRequest(url,options).then(result => {
      //   return planGroupUtil.findVersionedPlanGroupId(versionInfo)
      // }).then(portalGroupId => {
      //   return planGroupUtil.deletePlanGroup(portalGroupId)
      // }).then(result => {
        if (this.featureServicePerPlan) {
          const lenient = true;
          return versionUtil.deleteVersionSupportService(versionInfo,lenient);
        }
      }).then(result => {
        resolve();
      }).catch(ex => {
        reject(ex);
      });
    });
    return promise;
  }

  differences(task) {
    const lib = Context.instance.lib;
    const guid = task.guid;
    let url = (task && task.versionManagerUrl) || this.url;
    url += "/versions/" + encodeURIComponent(guid) + "/differences";
    //task.resultType = "features";
    const params = {
      f: "json",
      sessionID: task.sessionID,
      resultType: task.resultType || "objectIds"
    };
    const options = {query: params, method: "post", responseType: "json"};
    const promise = lib.esri.esriRequest(url,options);
    promise.then(result => {
      //console.log("VersionManager.differences",result)
      if (task.resultType === "features") {
        task.differences = result && result.data && result.data.features;
      } else {
        task.differences = result && result.data && result.data.differences;
      }
      if (Array.isArray(task.differences)) {
        task.differences.some(d => {
          let hasDiff = false;
          if (d.updates && d.updates.length > 0) {
            hasDiff = true;
          } else if (d.inserts && d.inserts.length > 0) {
            hasDiff = true;
          } else if (d.deletes && d.deletes.length > 0) {
            hasDiff = true;
          }
          if (hasDiff) task.hasDifferences = true;
          return hasDiff;
        })
      }
    });
    return promise;
  }

  hasDifferences(options) {
    const promise = new Promise((resolve,reject) => {
      const versionInfo = options.plan.versionInfo;
      let guid = versionInfo.versionGuid;
      guid = guid.replace("{","").replace("}","");
      const task = {
        guid: guid,
        sessionID: val.generateRandomUuid({includeBraces: true}),
        triedStop: false,
        hasDifferences: false,
        resultType: options.resultType || "objectIds"
      };
      this.startReading(task).then(() => {
        return this.differences(task);
      }).then(() => {
        task.triedStop = true;
        return this.stopReading(task);
      }).then(() => {
        resolve(task);
      }).catch(ex => {
        if (task.hasReadSession && !task.triedStop) {
          this.stopReading(task).then(() => {
          }).catch(ex2 => {
            console.error("Error stopping read session",ex2);
          });
        }
        reject(ex);
      });
    });
    return promise
  }

  findVersionInfo(planId) {
    let found = null;
    if (Array.isArray(this.versionInfos)) {
      this.versionInfos.some(versionInfo => {
        if (versionInfo.versionGuid === planId) {
          found = versionInfo;
        }
        return !!found;
      });
    }
    return found;
  }

  getVersionDate(versionInfo) {
    return versionInfo && new Date(versionInfo.creationDate);
  }

  getVersionTitle(versionInfo) {
    let v = versionInfo && versionInfo.versionName;
    if (typeof v !== "string") v = "Untitled";
    const idx = v.lastIndexOf(".");
    if (idx !== -1) v = v.substring(idx + 1);
    return v;
  }

  getVersionOwner(versionInfo) {
    let v = versionInfo && versionInfo.versionName;
    if (typeof v !== "string") v = "";
    const idx = v.lastIndexOf(".");
    if (idx !== -1) v = v.substring(0,idx);
    return v;
  }

  isOwner(versionInfo) {
    const owner = this.getVersionOwner(versionInfo);
    const username = Context.instance.user.getUsername();
    return (username && owner && (owner.toLowerCase() === username.toLowerCase()));
  }

  load(url) {
    this.url = url;
    const task = {
      versionManagerUrl: url
    };
    const promise = new Promise((resolve,reject) => {
      this.readServiceInfo(task).then(() => {
        this.serviceInfo = task.serviceInfo;
        return this.readVersionInfos(task);
      }).then(() => {
        this.versionInfos = task.versionInfos;
        resolve();
      }).catch(ex => {
        reject(ex);
      });
    });
    return promise;
  }

  mergePlan(options) {
    const promise = new Promise((resolve,reject) => {
      const versionInfo = options.plan.versionInfo;
      let guid = versionInfo.versionGuid;
      guid = guid.replace("{","").replace("}","");
      const task = {
        guid: guid,
        sessionID: val.generateRandomUuid({includeBraces: true}),
        triedStopEditing: false,
        triedStopReading: false,
        wasMerged: false
      };
      const withPost = true;
      this.startReading(task).then(() => {
        return this.startEditing(task);
      }).then(() => {
        return this.reconcile(task,withPost);
      }).then(() => {
        if (task.reconcile && !task.reconcile.didPost && task.reconcile.hasConflicts) {
          return this.reconcile(task,withPost);
        }
      }).then(() => {
        if (task.reconcile) {
          task.wasMerged = !!task.reconcile.didPost;
        }
        task.triedStopEditing = true;
        return this.stopEditing(task,false);
      }).then(() => {
        task.triedStopReading = true;
        return this.stopReading(task);
      }).then(() => {
        //console.log("VersionManager.mergePlan",task)
        resolve(task);
      }).catch(ex => {
        if (task.hasEditSession && !task.triedStopEditing) {
          this.stopEditing(task,false).then(() => {
          }).catch(ex2 => {
            console.error("Error stopping edit session",ex2);
          });
        }
        if (task.hasReadSession && !task.triedStopReading) {
          this.stopReading(task).then(() => {
          }).catch(ex2 => {
            console.error("Error stopping read session",ex2);
          });
        }
        reject(ex);
      });
    });
    return promise
  }

  readServiceInfo(task) {
    const lib = Context.instance.lib;
    const url = (task && task.versionManagerUrl) || this.url;
    const options = {query: {f: "json"}, responseType: "json"};
    const promise = lib.esri.esriRequest(url,options);
    promise.then(result => {
      task.serviceInfo = result && result.data;
    });
    return promise;
  }

  readVersionInfos(task) {
    const lib = Context.instance.lib;
    let url = (task && task.versionManagerUrl) || this.url;
    url += "/versionInfos";
    const options = {query: {f: "json"}, responseType: "json"};
    const promise = lib.esri.esriRequest(url,options);
    promise.then(result => {
      const versionInfos = result && result.data && result.data.versions;
      if (versionInfos) {
        versionInfos.forEach(vi => {
          vi.xtnTitle = this.getVersionTitle(vi);
        });
        versionInfos.sort((a,b) => {
          if (a.versionId === 0) return 0;
          else if (b.versionId === 0) return 1;
          return a.xtnTitle.localeCompare(b.xtnTitle);
        });
      }
      task.versionInfos = versionInfos;
    });
    return promise;
  }

  readVersions(task) {
    const lib = Context.instance.lib;
    let url = (task && task.versionManagerUrl) || this.url;
    url += "/versions";
    const options = {query: {f: "json"}, responseType: "json"};
    const promise = lib.esri.esriRequest(url,options);
    promise.then(result => {
      task.versions = result && result.data;
    });
    return promise;
  }

  reconcile(task,withPost) {
    const lib = Context.instance.lib;
    const guid = task.guid;
    let url = (task && task.versionManagerUrl) || this.url;
    url += "/versions/" + encodeURIComponent(guid) + "/reconcile";
    const params = {
      f: "json",
      sessionID: task.sessionID,
      abortIfConflicts: false,
      withPost: !!withPost
    };
    const options = {query: params, method: "post", responseType: "json"};
    const promise = lib.esri.esriRequest(url,options);
    promise.then(result => {
      task.reconcile = result && result.data;
      //console.log("task.reconcile",task.reconcile)
    });
    return promise;
  }

  reconcilePlan(options) {
    const promise = new Promise((resolve,reject) => {
      const versionInfo = options.plan.versionInfo;
      let guid = versionInfo.versionGuid;
      guid = guid.replace("{","").replace("}","");
      const task = {
        guid: guid,
        sessionID: val.generateRandomUuid({includeBraces: true}),
        triedStopEditing: false,
        triedStopReading: false,
        wasMerged: false
      };
      this.startReading(task).then(() => {
        return this.startEditing(task);
      }).then(() => {
        return this.reconcile(task);
      }).then(() => {
        task.triedStopEditing = true;
        return this.stopEditing(task,false);
      }).then(() => {
        task.triedStopReading = true;
        return this.stopReading(task);
      }).then(() => {
        resolve(task);
      }).catch(ex => {
        if (task.hasEditSession && !task.triedStopEditing) {
          this.stopEditing(task,false).then(() => {
          }).catch(ex2 => {
            console.error("Error stopping edit session",ex2);
          });
        }
        if (task.hasReadSession && !task.triedStopReading) {
          this.stopReading(task).then(() => {
          }).catch(ex2 => {
            console.error("Error stopping read session",ex2);
          });
        }
        reject(ex);
      });
    });
    return promise
  }

  startEditing(task) {
    const lib = Context.instance.lib;
    let url = (task && task.versionManagerUrl) || this.url;
    url += "/versions/" + encodeURIComponent(task.guid) + "/startEditing";
    const params = {
      f: "json",
      sessionID: task.sessionID
    };
    const options = {query: params, method: "post", responseType: "json"};
    const promise = lib.esri.esriRequest(url,options);
    promise.then(result => {
      const ok = result && result.data && result.data.success;
      task.hasEditSession = !!ok;
      //console.log("task.startEditing",result)
    });
    return promise;
  }

  startReading(task) {
    const lib = Context.instance.lib;
    let url = (task && task.versionManagerUrl) || this.url;
    url += "/versions/" + encodeURIComponent(task.guid) + "/startReading";
    const params = {
      f: "json",
      sessionID: task.sessionID
    };
    const options = {query: params, method: "post", responseType: "json"};
    const promise = lib.esri.esriRequest(url,options);
    promise.then(result => {
      const ok = result && result.data && result.data.success;
      task.hasReadSession = !!ok;
      //console.log("task.startReading",result)
    });
    return promise;
  }

  stopEditing(task,saveEdits) {
    const lib = Context.instance.lib;
    let url = (task && task.versionManagerUrl) || this.url;
    url += "/versions/" + encodeURIComponent(task.guid) + "/stopEditing";
    const params = {
      f: "json",
      sessionID: task.sessionID,
      saveEdits: !!saveEdits
    };
    const options = {query: params, method: "post", responseType: "json"};
    const promise = lib.esri.esriRequest(url,options);
    promise.then(result => {
      const ok = result && result.data && result.data.success;
      if (ok) task.hasEditSession = false;
      //console.log("task.stopEditing",result)
    });
    return promise;
  }

  stopReading(task) {
    const lib = Context.instance.lib;
    let url = (task && task.versionManagerUrl) || this.url;
    url += "/versions/" + encodeURIComponent(task.guid) + "/stopReading";
    const params = {
      f: "json",
      sessionID: task.sessionID
    };
    const options = {query: params, method: "post", responseType: "json"};
    const promise = lib.esri.esriRequest(url,options);
    promise.then(result => {
      const ok = result && result.data && result.data.success;
      if (ok) task.hasReadSession = false;
      //console.log("task.stopReading",result)
    });
    return promise;
  }

}
